import { SxProps, Theme } from "@mui/material";
import { colors } from "../../../colors/colors";

export const modalBoxStyles: SxProps<Theme> = (theme: Theme) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "16px",
  padding: "22px",
  boxShadow: 24,
  backgroundColor: theme.palette.modalColors.bgColor,
  width: { xs: "90%", sm: "70%", md: "60%" },
  maxHeight: { xs: "80dvh", sm: "80dvh", md: "80dvh" },
  overflowY: "auto",
});

export const smallModalBoxStyles: SxProps<Theme> = (theme: Theme) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "16px",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "16px",
  padding: "2rem 5rem",
  boxShadow: 24,
  backgroundColor: theme.palette.modalColors.bgColor,
  maxHeight: { xs: "80dvh", sm: "80dvh", md: "80dvh" },
  overflowY: "auto",
});

export const topContainerStyles: SxProps = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
};

export const buttonsContainerStyles: SxProps = {
  marginY: "1rem",
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  gap: "1rem",
};

export const mainButtonStyles: SxProps = {
  height: "40px",
  borderRadius: "20px",
  paddingX: "2rem",
  textTransform: "none",
  background: "rgb(25, 118, 210)",
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none",
    background: "rgb(17, 100, 183)",
  },
};

export const secondaryButtonStyles: SxProps = {
  height: "40px",
  borderRadius: "20px",
  paddingX: "2rem",
  textTransform: "none",
  color: "rgb(25, 118, 210)",
  borderColor: "rgb(25, 118, 210)",
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none",
    backgroundColor: "rgba(25, 118, 210, 0.1)",
  },
};

export const closeButtonContainerStyles: SxProps = {
  margin: "1rem auto",
};

export const fieldContainerStyles: SxProps = {
  marginY: "0.5rem",
  display: "flex",
  flexDirection: "column",
  gap: "0.25rem",
};

export const getTextFieldStyles =
  (error: boolean): SxProps<Theme> =>
  (theme: Theme) => ({
    "& .MuiFormLabel-root": {
      zIndex: 3000,
      color: error ? colors.error : theme.palette.adminPanel.textColor,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: error
        ? colors.error
        : theme.palette.panelInfo.selector.borderColor,
    },
    "&:hover .MuiFormLabel-root": {
      color: error ? colors.error : theme.palette.adminPanel.textColor,
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: error ? colors.error : "#06B6D4",
    },
    "& .MuiFormLabel-root.Mui-focused": {
      color: error ? colors.error : "#06B6D4",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: error ? colors.error : "#06B6D4",
    },
  });

export const popperStyles: SxProps<Theme> = (theme: Theme) => ({
  "& .MuiPaper-root": {
    "--Paper-overlay": "none !important",
    backgroundColor: theme.palette.adminPanel.calendarBg,
    borderRadius: 2,
    boxShadow: "0 4px 16px rgba(0, 0, 0, 0.1)",
  },
});

export const layoutStyles: SxProps = {
  "& .MuiPickersCalendarHeader-root": {
    borderRadius: 1,
    mb: 1,
  },
};

export const dayStyles: SxProps<Theme> = (theme: Theme) => ({
  borderRadius: "10px",
  "&:hover": {
    backgroundColor: theme.palette.adminPanel.calendarBgHover,
  },
  "&.Mui-selected": {
    backgroundColor: "#06B6D4 !important",
    color: "#fff !important",
  },
  "&.MuiPickersDay-today": {
    color: "#06B6D4",
    border: "none",
    backgroundColor: theme.palette.adminPanel.calendarTodayBg,
  },
});

export const yearButtonStyles = (theme: any) => ({
  "&.Mui-selected": {
    backgroundColor: "#06B6D4 !important",
    color: "#fff !important",
  },
  "&:hover": {
    backgroundColor: theme.palette.adminPanel.calendarBgHover,
  },
});

export const menuItemStyles: SxProps = {
  width: "100%",
  fontSize: "14px",
  zIndex: 2001,
};

export const getInputLabelStyles =
  (error: boolean): SxProps<Theme> =>
  (theme: Theme) => ({
    fontFamily: "Red Hat Display",
    color: error ? colors.error : theme.palette.adminPanel.textColor,

    "&.MuiFormLabel-root.Mui-focused": {
      color: error ? colors.error : "#06B6D4",
    },
  });

export const getSelectStyles =
  (error: boolean): SxProps<Theme> =>
  (theme: Theme) => ({
    // for errors
    color: error ? colors.error : theme.palette.adminPanel.textColor,
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: error ? colors.error : theme.palette.adminPanel.borderColor,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: error ? colors.error : "#06B6D4",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: error ? colors.error : "#06B6D4",
    },
  });

export const errorTypographyStyles: SxProps = {
  fontFamily: "Red Hat Display",
  color: colors.error,
  textAlign: "left",
  margin: 0,
};

export const formBlockStyles: SxProps = {
  marginY: "0.5rem",
  display: "flex",
  flexDirection: "column",
  gap: "16px",

  "& > *:not(p)": {
    marginLeft: "1rem",
  },
};
